import createSelectors from './createSelectors';
import ParticipationAndQuestionnaire from '../models/ParticipationAndQuestionnaire';

const Select = createSelectors(ParticipationAndQuestionnaire, {});

export default Select;
